import React from "react";

import { themeColor } from "src/styles";

import { Box, Flex, Link, Image, Text } from "src/components/base";

import LearnMoreLink from "src/components/LearnMoreLink";

export default ({ item, height, ...props }) => (
  <Box flex={1}>
    <Link
      flex={1}
      flexDirection="row"
      style={{ position: "relative", height }}
      borderRadius={2}
      to={item.url || item.link}
    >
      {item.image && (
        <Image
          sizes={item.image.sizes}
          fadeIn={true}
          alt={item.image.description || item.image.title}
          style={{
            display: "block",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
          }}
          borderRadius={2}
        />
      )}
      <Box
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        }}
        bg={themeColor(item.theme, true)}
        p={2}
        borderRadius={2}
      >
        <Text color="white" fontWeight="semibold">
          {item.title || item.caption}
        </Text>
      </Box>
    </Link>
    <Flex justify="flex-end" mt={3}>
      <LearnMoreLink to={item.url || item.link} title={item.title} />
    </Flex>
  </Box>
);

export const photoWithCaptionFragment = graphql`
  fragment ArticleWithPhoto on ContentfulArticle {
    id
    title
    theme
    url
    image {
      description
      title
      resolutions(height: 300, quality: 80) {
        ...GatsbyContentfulResolutions_withWebp
      }
      sizes(maxWidth: 500, quality: 80) {
        ...GatsbyContentfulSizes_withWebp
      }
    }
  }

  fragment PageWithPhoto on ContentfulPage {
    id
    title
    theme
    url
    image: embedImage {
      description
      title
      resolutions(height: 300, quality: 80) {
        ...GatsbyContentfulResolutions_withWebp
      }
      sizes(maxWidth: 500, quality: 80) {
        ...GatsbyContentfulSizes_withWebp
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/ItemGroup/PhotoWithCaption.js